import { useMediaBreakPoint } from '@gaming1/g1-ui';

export const breakPointMobileTicket = 'md';

export const useIsMobileTicket = () =>
  useMediaBreakPoint({ max: breakPointMobileTicket });

export const useIsDesktopTicket = () =>
  useMediaBreakPoint({ min: breakPointMobileTicket });
